import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { createUrl } from './helpers'
import axiosAuth from './config'
import { NSocietiesWebsites } from '../interfaces/services/societies-websites.interfaces'

export const getWebsitePerSociety = (
  societyId: string
): Promise<AxiosResponse<NSocietiesWebsites.NGetPerSocieties.IResponse>> => {
  return axiosAuth.get<NSocietiesWebsites.NGetPerSocieties.IResponse>(
    createUrl(`/societies-websites/get-per-society/${societyId}`)
  )
}

export const patchWebsite = (params: {
  id: string
  body: NSocietiesWebsites.NPatch.IRequestBody
}): Promise<AxiosResponse<NSocietiesWebsites.NPatch.IResponse>> => {
  return axiosAuth.patch<NSocietiesWebsites.NPatch.IResponse>(
    createUrl(`/societies-websites/website/${params.id}`),
    params.body
  )
}

export const websiteQueries = {
  getWebsitePerSociety: (societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'website', entity: 'society', societyId }],
      enabled: !!societyId,
      queryFn: async ({ queryKey }) => {
        const { data } = (await getWebsitePerSociety(queryKey[0].societyId!))
          .data
        return data?.[0]
      },
    }),
}
